<nav aria-label="Suggestion pages">
    <button
        qpxButton="unstyled"
        aria-label="Previous suggestions"
        (click)="previous.emit()"
    >
        <ng-icon qpx size="sm" name="lucideChevronLeft" />
    </button>
    <div class="dots">
        @for (page of pageNumbers(); track page) {
            <button
                qpxButton="unstyled"
                [attr.aria-label]="`Show suggestion set ${page}`"
                [attr.aria-current]="page === currentPage() ? 'page' : null"
                (click)="pageSelected.emit(page)"
            >
                <span class="dot" aria-hidden="true"></span>
            </button>
        }
    </div>
    <button
        qpxButton="unstyled"
        aria-label="Next suggestions"
        (click)="next.emit()"
    >
        <ng-icon qpx size="sm" name="lucideChevronRight" />
    </button>
</nav>
<output class="sr-only">Set {{ currentPage() }} of {{ totalPages() }}</output>
